export default "__VITE_ASSET__vlwOVXWe__"